const LandingPage = class Field {
    constructor() {
        this.title = '';
        this.description = '';
        this.sessionIds = [];
        this.themes = [];
    }
};

export default LandingPage;
